import Model, { type ModelError } from '@models/base/base.model';

import type EventStore from '@stores/event.store';

type CreateEvent = {
  id: Model['id'];
};

export default class EventModel extends Model {
  store: EventStore;

  constructor(store: EventStore, event: CreateEvent) {
    super(store, event.id, false);
    this.store = store;
  }

  get toJSON() {
    return {};
  }

  public delete() {
    return this.store.delete(this.id);
  }

  public get errors(): ModelError[] {
    return [];
  }
}
